import React, { Component } from "react";

import Data16 from "@carbon/icons-react/lib/data--1/16";
import PageBreadCrumb from "./../../helpers/PageBreadCrumb";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { AppContext } from "./../../helpers/context/AppContext";
import { ComboBox } from "../../helpers/ComboBox";
import { ConfirmAlertCustom } from "./../../helpers/ConfirmAlertCustom";
import { Download16, Add16, Edit16, Delete16 } from "@carbon/icons-react";
import { Online } from "./../common/OnLineOffLine";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import {
	Search,
	TableToolbar,
	Loading,
	Button,
	Form,
	FormGroup,
	FormLabel,
	TextInput,
	DataTable,
	TableContainer,
	DataTableSkeleton,
	Pagination,
	Table,
	TableHead,
	TableRow,
	TableHeader,
	TableBody,
	TableCell,
	ComposedModal,
	ModalHeader,
	ModalBody,
} from "carbon-components-react";
import { api, kpi } from "./../../helpers/api/api";
import { entitiesLabels, apioperation, getError, getSuccess } from "../../helpers/Constants";
import { showNotification } from "./../../helpers/notification/BaseNotification";
import { v4 as uuid } from "uuid";

const searchProp = {
	idKpi: null,
	idDivision: null,
	allDivisions: true,
	year: 0,
	quarter: null,
};

const modelProp = {
	idKpi: null,
	idDivision: null,
	year: 0,
	quarter: null,
	kpiValue: null,
};

const quarters = ["Q1", "Q2", "Q3", "Q4"];

export class KpiManualInput extends Component {
	constructor(props) {
		super(props);
		this.validator = new SimpleReactValidator();

		this.state = {
			// Paging
			currentPage: 1,
			pageSize: 10,
			rowCount: 0,

			// Loaders
			isExportLoading: false,
			isLoadingEntity: false,
			isSearchFormExpanded: false,

			// Combobox lists
			kpis: [],
			divisions: [],

			// Search-related fields
			search: { ...searchProp },

			// Main lists
			kpiManualInputListPaged: [],
			kpiManialInputListAll: [],

			// Edit modal
			isUpdateMode: false,
			isEditModalOpen: false,

			// Insert / edit model
			model: { ...modelProp },

			// Delete
			idToDelete: null,
			isDeleting: false,
			isDeleteModalOpen: false,

			// Used for update
			oldIdKpi: null,
			oldYear: null,
			oldQuarter: null,
			oldIdDivision: null,
		};
	}

	componentDidMount() {
		this.getAllHseKpis();
		this.getAllDivisions();
		this.getAllManualInputKpis();

		// Main list
		this.getPagedFilteredManualInputKpis();
	}

	getAllHseKpis = () => {
		kpi.hse.getAll().then((res) => {
			this.setState({ kpis: res.data });
		});
	};

	getAllDivisions = () => {
		api.getAll("/division").then((res) => {
			res.data.push({ id: -1, name: "Group" });
			this.setState({ divisions: res.data });
		});
	};

	getPagedFilteredManualInputKpis = (param) => {
		this.setState({ isLoadingEntity: true });

		const filter = {
			page: param && param.page ? param.page : this.state.currentPage,
			pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
			idKpi: this.state.search.idKpi,
			idDivision: this.state.search.idDivision,
			allDivisions: this.state.search.allDivisions,
			year: this.state.search.year,
			quarter: this.state.search.quarter,
		};

		const data = { params: { ...filter } };

		kpi.mi
			.getWithParam(data)
			.then((res) => {
				if (res.status === 200) {
					const { data } = res;
					this.setState({
						currentPage: data.currentPage,
						pageSize: data.pageSize,
						rowCount: data.rowCount,
						kpiManualInputListPaged: data.itemList,
					});
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.KPIMANUALINPUT, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingEntity: false });
			});
	};

	getAllManualInputKpis = () => {
		kpi.mi
			.getAll()
			.then((res) => {
				if (res.status === 200) {
					this.setState({ kpiManialInputListAll: res.data });
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.KPIMANUALINPUT, apioperation.GET));
			})
			.finally(() => {});
	};

	// Modals
	openAddNewModal = () => {
		this.setState({
			isUpdateMode: false,
			isEditModalOpen: true,
		});
	};

	closeEditModal = () => {
		this.setState({
			model: { ...modelProp },
			isEditModalOpen: false,
			oldIdKpi: null,
			oldYear: null,
			oldQuarter: null,
			oldIdDivision: null,
		});
		this.validator.hideMessages();
	};

	// Search
	toggleSearchForm = (e) => {
		e.preventDefault();
		this.setState((oldState) => ({ isSearchFormExpanded: !oldState.isSearchFormExpanded }));
	};

	handleClickCancelSearch = (e) => {
		e.preventDefault();
		this.setState(
			{
				search: { ...searchProp },
				isSearchFormExpanded: false,
			},
			() => {
				this.getPagedFilteredManualInputKpis({ page: 1 });
			}
		);
	};

	handleClickSearch = (e) => {
		e.preventDefault();
		this.getPagedFilteredManualInputKpis({ page: 1 });
	};

	// Excel export
	downloadFile() {
		if (this.state.isExportLoading) return;

		this.setState({ isExportLoading: true });

		api.getWithParam("/admin/kpimanualinput/excel", { responseType: "arraybuffer" })
			.then((response) => {
				var data = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				var csvURL = window.URL.createObjectURL(data);
				var tempLink = document.createElement("a");
				tempLink.href = csvURL;

				var fileName = "Export_" + "KPIManualInput_" + moment().format("YYYYMMDDHHmmSS") + ".xlsx";
				tempLink.setAttribute("download", fileName);

				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Download File", apioperation.GET));
			})
			.finally(() => {
				this.setState({ isExportLoading: false });
			});
	}

	// Search form handlers
	updateStateSearch = (inputName, inputValue, objName) => {
		const stateCopy = { ...this.state.search };
		stateCopy[inputName] = inputValue;
		this.setState({ search: stateCopy });
	};

	handleChangeComboSearch = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem && selectedItem.id;
		const stateCopy = { ...this.state };
		stateCopy[objName][inputName] = inputValue;
		if (inputName === "idDivision") stateCopy[objName]["allDivisions"] = !selectedItem;
		this.setState(stateCopy);
	};

	handleChangeQuarterSearch = (inputName, selectedItem, objName) => {
		const stateCopy = { ...this.state };
		stateCopy[objName][inputName] = selectedItem;
		this.setState(stateCopy);
	};

	handleChangeYearSearch = (el) => {
		const inputName = el.target.name;
		const inputValue = el.target.value || 0;
		const objName = el.target.alt;

		this.updateStateSearch(inputName, inputValue, objName);
	};

	// Edit modal handlers
	handleChangeModelKpi = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const stateCopy = { ...this.state };
		stateCopy[objName][inputName] = inputValue;
		stateCopy.model.quarter = null;
		stateCopy.model.year = 0;

		this.setState(stateCopy);
	};

	handleChangeModelNumeric = (el) => {
		const inputName = el.target.name;
		const inputValue = el.target.value;
		const objName = el.target.alt;

		this.updateState(inputName, inputValue, objName);
	};

	handleChangeModelQuarter = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem : null;
		const stateCopy = { ...this.state };

		if (this.state.model.idKpi != null && this.state.model.year != null && selectedItem != null) {
			var kpi = this.state.kpiManialInputListAll.find((k) => k.idKpi == this.state.model.idKpi && k.year == this.state.model.year && k.quarter == selectedItem);
		}
		stateCopy[objName][inputName] = inputValue;
		stateCopy.model.idKpi = this.state.model.idKpi;
		this.setState(stateCopy);
	};

	handleChangeModelDivision = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const stateCopy = { ...this.state };
		stateCopy[objName][inputName] = inputValue;

		this.setState(stateCopy);
	};

	// Edit modal insertion
	insertKpiManualInput = () => {
		let idDivision = this.state.model.idDivision === -1 ? null : this.state.model.idDivision;
		if (this.validator.allValid()) {
			this.setState({
				isSubmitted: true,
			});

			const formData = this.state?.model;
			if (!this.state.isUpdateMode) {
				formData.id = uuid();
			} else {
				formData.oldIdKpi = this.state.oldIdKpi;
				formData.oldYear = this.state.oldYear;
				formData.oldQuarter = this.state.oldQuarter;
				formData.oldIdDivision = this.state.oldIdDivision;
			}
			formData.idDivision = idDivision;

			const method = this.state.isUpdateMode ? kpi.mi.put(formData) : kpi.mi.post(formData);

			method
				.then(async (response) => {
					if (response.status === 200) {
						showNotification.success(`${entitiesLabels.SUCCESS}`, "Successfully saved");
						this.setState(
							{
								isLoading: false,
							},
							this.closeEditModal
						);
					} else {
						showNotification.error(`${entitiesLabels.ERROR}`, getError("Unsuccessfully saved", entitiesLabels.KPIMANUALINPUT, apioperation.POST));
					}
				})
				.catch((error) => {
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.KPIMANUALINPUT, apioperation.POST));
				})
				.finally(() => {
					this.setState(
						{
							isLoading: false,
						},
						() => {
							this.getPagedFilteredManualInputKpis();
							this.getAllManualInputKpis();
							this.forceUpdate();
						}
					);
				});
		} else {
			this.validator.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.KPIMANUALINPUT} required fields are missing  `);
			this.forceUpdate();
		}
	};

	// Edit modal update
	getKpiForEdit = (id) => {
		this.setState({
			isUpdateMode: true,
			isEditModalOpen: true,
		});
		let kpiToChange = this.state.kpiManualInputListPaged.find((x) => x.id == id);
		if (kpiToChange.division == null) {
			kpiToChange.division = { id: -1, name: "Group" };
		}
		this.setState({
			model: kpiToChange,

			oldIdKpi: kpiToChange.idKpi,
			oldYear: kpiToChange.year,
			oldQuarter: kpiToChange.quarter,
			oldIdDivision: kpiToChange.idDivision,
		});
	};

	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state.model };
		if (objName && objName != "model") statusCopy[objName][inputName] = inputValue;
		else statusCopy[inputName] = inputValue;
		if (inputName === "year") statusCopy.quarter = null;

		this.setState({ model: statusCopy });
	};

	// Delete modal
	confirmDelete = (id) => {
		this.setState({
			idToDelete: id,
			isDeleteModalOpen: true,
			isDeleting: false,
		});
	};

	deleteItem = () => {
		let id = this.state.idToDelete;
		this.setState({ isDeleting: true });
		const formData = this.state.kpiManualInputListPaged.find((x) => x.id === id);

		kpi.mi
			.delete(formData)
			.then((response) => {
				if (response.status === 200) {
					this.setState({
						idToDelete: null,
						isDeleteModalOpen: false,
					});
					this.onCloseConfirm();
					this.getPagedFilteredManualInputKpis();
					this.getAllManualInputKpis();
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.KPIMANUALINPUT, apioperation.DELETE));
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.KPIMANUALINPUT, apioperation.DELETE));
			})
			.finally(() => {
				this.setState({ isDeleting: false });
			});
	};

	getNameById = (id) => {
		if (id == null) return "";
		let element = this.state.kpiManialInputListAll.find((el) => el.id == id);
		return element != null ? `${element.code} ${element.name} - ${element.year}[${element.quarter}] - ${element.division}` : "";
	};

	onCloseConfirm = () => {
		this.setState({ isDeleteModalOpen: false });
	};

	// Render methods
	renderSearchForm = () =>
		this.state.isSearchFormExpanded && (
			<div>
				<Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
					<FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
						<FormLabel>Kpi</FormLabel>
						<ComboBox
							id="idKpiSearch"
							placeholder="All"
							name="idKpi"
							alt="search"
							onChange={this.handleChangeComboSearch}
							itemToString={(item) => (item.name ? item.code + " - " + item.name : "")}
							initialSelectedItem={this.state.search.idKpi != null ? this.state.search.idKpi : []}
							items={this.state.kpis}
						/>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
						<FormLabel>Year</FormLabel>
						<TextInput id="yearsearch" name="year" alt="search" placeholder="All" min={0} value={this.state.search.year || ""} onChange={this.handleChangeYearSearch} type="number" hideLabel />
					</FormGroup>
					<FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
						<FormLabel>Quarter</FormLabel>
						<ComboBox
							id="idQuarterSearch"
							placeholder="All"
							name="quarter"
							alt="search"
							onChange={this.handleChangeQuarterSearch}
							itemToString={(item) => item || ""}
							initialSelectedItem={this.state.search.quarter || []}
							items={quarters}
							direction="top"
						/>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
						{/* RITM0945977 */}
						{/* <FormLabel>Division</FormLabel> */}
						<FormLabel>Business Line</FormLabel>
						<ComboBox
							id="idDivisionGroupSearch"
							placeholder="All"
							name="idDivision"
							alt="search"
							onChange={this.handleChangeComboSearch}
							itemToString={(item) => item.name || ""}
							initialSelectedItem={this.state.search.division || []}
							items={this.state.divisions}
							direction="top"
						/>
					</FormGroup>
				</Form>
				<div className="searchFormFooter">
					<Button className="button--max-width" size="small" kind="secondary" onClick={this.handleClickCancelSearch}>
						Cancel
					</Button>
					<Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
						Search
					</Button>
				</div>
			</div>
		);

	renderDetailsForm() {
		const modalHeader = {
			title: (this.state.isUpdateMode ? "Edit " : "Add new ") + "KPI Manual Input",
			iconDescription: "Close",
			buttonOnClick: () => this.closeEditModal(),
		};

		const validations = {
			year: this.validator.message("year", this.state.model.year, "numeric|min:1,num"),
			quarter: this.validator.message("quarter", this.state.model.quarter, "required"),
			kpi: this.validator.message("kpi", this.state.model.idKpi, "required"),
			kpiValue: this.validator.message("value", this.state.model.kpiValue, "required"),
			// division: this.validator.message("division", this.state.model.idDivision, "required"), //RITM0945977
			division: this.validator.message("businessLine", this.state.model.idDivision, "required"),
		};

		return (
			<ComposedModal className="light-modal" open={this.state.isEditModalOpen} danger="false" onClose={() => this.closeEditModal()}>
				<ModalHeader className="margin-modal" {...modalHeader} />
				<ModalBody className="margin-modal margin-modal-content">
					<Form className="bx--grid--full-width">
						<div className="bx--row">
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Kpi*</FormLabel>
								<ComboBox
									id="idKpi"
									placeholder=" "
									name="idKpi"
									alt="model"
									onChange={this.handleChangeModelKpi}
									itemToString={(item) => (item.name ? item.code + " - " + item.name : "")}
									initialSelectedItem={this.state.model.kpi || []}
									items={this.state.kpis}
									invalid={validations.kpi != null}
								/>
								{validations.kpi}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Year*</FormLabel>
								<TextInput
									id="year"
									name="year"
									alt="model"
									placeholder=""
									min={0}
									value={this.state.model.year === 0 ? "" : this.state.model.year}
									onChange={this.handleChangeModelNumeric}
									type="number"
									hideLabel
									labelText=""
									disabled={this.state.model?.idKpi != null ? false : true}
									invalid={validations.year != null}
								/>
								{validations.year}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Quarter*</FormLabel>
								<ComboBox
									key={"idquarter" + this.state.model.quarter}
									id="idquarter"
									placeholder=""
									name="quarter"
									alt="model"
									onChange={this.handleChangeModelQuarter}
									itemToString={(item) => item || ""}
									initialSelectedItem={this.state.model.quarter || []}
									items={quarters}
									direction="bottom"
									disabled={this.state.model?.year === 0}
									invalid={validations.quarter != null}
								/>
								{validations.quarter}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								{/* RITM0945977 */}
								{/* <FormLabel>Division*</FormLabel> */}
								<FormLabel>Business Line*</FormLabel>
								<ComboBox
									id="idDivision"
									placeholder=""
									name="idDivision"
									alt="model"
									onChange={this.handleChangeModelDivision}
									itemToString={(item) => (item && item.name) || ""}
									initialSelectedItem={this.state.model.division || []}
									items={this.state.divisions}
									direction="bottom"
									invalid={validations.division != null}
								/>
								{validations.division}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Value*</FormLabel>
								<TextInput
									id="kpiValue"
									name="kpiValue"
									alt="model"
									placeholder=""
									min={0}
									value={this.state.model.kpiValue == null ? "" : this.state.model.kpiValue}
									onChange={this.handleChangeModelNumeric}
									type="number"
									hideLabel
									labelText=""
									disabled={this.state.model?.idKpi == null}
									invalid={validations.kpiValue != null}
								/>
								{validations.kpiValue}
							</FormGroup>
						</div>
					</Form>
				</ModalBody>
				<div className="bx--modal-footer">
					<Button className="button--max-width" kind="secondary" onClick={this.closeEditModal}>
						Cancel
					</Button>
					<Button className="button--max-width" kind="primary" onClick={this.insertKpiManualInput}>
						Save
					</Button>
				</div>
			</ComposedModal>
		);
	}

	handleChangePaging = (event) => {
		this.getPagedFilteredManualInputKpis(event);
		//RITM0539773
	};

	render() {
		this.validator.purgeFields();

		const dataTableHeaders = [
			{ key: "code", header: "Code" },
			{ key: "name", header: "Name" },
			{ key: "year", header: "Year" },
			{ key: "quarter", header: "Quarter" },
			//RITM0945977
			// { key: "divisionName", header: "Division" },
			{ key: "divisionName", header: "Business Line" },
			{ key: "kpiValue", header: "Value" },
		];

		const skeletonRowCount = this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount ? this.state.rowCount : 5;

		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.rowCount || 0,
			pageSize: this.state.pageSize || 10,
			pageSizes: [10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});

		const confirmDelProps = () => ({
			idToDelete: this.state.idToDelete,
			isDeleting: this.state.isDeleting,
			open: this.state.isDeleteModalOpen,
			onCloseConfirm: this.onCloseConfirm,
			deleteItem: this.deleteItem,
		});
		const itemToDelete = this.state.kpiManialInputListAll.find((el) => el.id == this.state.idToDelete);

		return (
			<AppContext.Consumer>
				{() => (
					<>
						<PageBreadCrumb linkTo={"/backoffice#Kpi"} linkText={"BackOffice"} titleLeft={"KPI Manual Input"} />
						<div className="mainContainer">
							<ConfirmAlertCustom {...confirmDelProps()}>
								{itemToDelete != null ? (
									<DataTable
										rows={[itemToDelete]}
										headers={dataTableHeaders.filter((h) => h.key != "name")}
										useZebraStyles={true}
										size="compact"
										render={({ rows, headers, getHeaderProps, getRowProps }) => (
											<TableContainer className="bx--grid--full-width deleting-item">
												<Table>
													<TableHead>
														<TableRow>
															{headers.map((header) => (
																<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																	{header.header}
																</TableHeader>
															))}
														</TableRow>
													</TableHead>
													<TableBody>
														{rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										)}
									/>
								) : null}
							</ConfirmAlertCustom>

							{this.state.isEditModalOpen ? this.renderDetailsForm() : ""}

							<TableToolbar>
								<form onSubmit={this.handleSearchFormSubmit} className="max-width" autoComplete="off">
									<Online>
										<Search readOnly light className="search cursor-pointer hiddenSearch" labelText="Search" placeHolderText="Search" id="search-1" onClick={this.toggleSearchForm} />
									</Online>
								</form>
								<Online>
									<Button onClick={this.toggleSearchForm} className="buttonPaddingIcon" renderIcon={Data16} iconDescription="Filter" />
									<Button onClick={() => this.downloadFile()} className="btn-notext" iconDescription=" " renderIcon={Download16}>
										{!this.state.isExportLoading ? "" : <Loading />}
									</Button>
								</Online>
								<Online>
									<Button onClick={() => this.openAddNewModal()} renderIcon={Add16}>
										Add New
									</Button>
								</Online>
							</TableToolbar>

							{this.state.isExportLoading ? <Loading /> : null}

							{this.renderSearchForm()}

							<DataTable
								rows={this.state.kpiManualInputListPaged}
								headers={dataTableHeaders}
								useZebraStyles={true}
								size="compact"
								render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
									<TableContainer className="bx--grid--full-width">
										{this.state.isLoadingEntity ? (
											<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
										) : (
											<Table>
												<TableHead>
													<TableRow>
														{headers.map((header) => (
															<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																{header.header}
															</TableHeader>
														))}
														<TableHeader className="align-center">Actions</TableHeader>
													</TableRow>
												</TableHead>
												<TableBody>
													{rows == null || rows.length === 0 ? (
														<NoRecordsPlaceholder colSpan={headers.length} />
													) : (
														rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
																<TableCell key={"action-" + row.id} className="tableActions align-center">
																	<div>
																		<Online>
																			<Button onClick={() => this.getKpiForEdit(row.id)} size="small" renderIcon={Edit16} iconDescription="Edit" kind="ghost" />
																			<Button onClick={() => this.confirmDelete(row.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" />
																		</Online>
																	</div>
																</TableCell>
															</TableRow>
														))
													)}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								)}
							/>

							<div className="footer-pagination">
								<Pagination {...paginationProps()} />
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
